import type { FaireProductEntity } from "../../entity_types/product";

export const p_dw4rxnfmwu: FaireProductEntity = {
  token: "p_dw4rxnfmwu",
  type: "product",
  name: "The Hunger Games Mockingjay Pin",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/21b593d7d34d6cf779d93e4a1d65d2e0f04a4371d80a2989d2fd7a7f28049d04.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.48,
  description: "Defy the Capitol and join the rebellion with this one-of-a-kind, officially licensed The Hunger Games collectible. Wear your 2-inch replica Mockingjay pin proudly or display it in the stand that makes Katniss’s signature whistle sound. The unique, wearable pin features an approximately 2-inch, metal, wearable replica of Katniss Everdeen’s Mockingjay pin with a display stand that plays Katniss’s whistle sound at the press of a button. This item also includes a sticker book with 10 full-color stickers featuring some of the most iconic lines and references from The Hunger Games films, making it the perfect gift for fans of The Hunger Games films. This collectible is officially licensed, ensuring authenticity and quality. Requires two AAA batteries (not included).",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:52.708Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
